import { QuestionModel } from '@/modules/core/domain/interfaces/IFormulary';
import useField from '@/modules/WebForm/hooks/useField';
import { createAnswer } from '@/modules/WebForm/utils';
import debounce from '@/utils/debounce';
import { useMaskedInput } from '@/utils/Masks';
import Masks from '@/utils/Masks/Masks';
import { Flex, Input, Textarea } from '@chakra-ui/react';
import React from 'react';

import AnswerHistory from '../AnswerHistory';
import FormControlComponent from '../FormControlComponent';

const TextContent: React.FC<QuestionModel & { isParagraph?: boolean }> = ({
  id,
  formularyId,
  inputMask,
  isParagraph,
}) => {
  const { onChange, fieldState, error } = useField();

  const debouncedOnChange = React.useMemo(() => debounce(onChange, 300), [
    onChange,
  ]);

  const [value, setValue] = React.useState(() => {
    if (fieldState && !Array.isArray(fieldState)) {
      return fieldState.content;
    }
    return '';
  });

  const handleChange = React.useCallback(
    (newValue: string) => {
      setValue(newValue);
      debouncedOnChange(createAnswer(newValue));
    },
    [debouncedOnChange],
  );

  const handleSelect = React.useCallback(
    (selectedValue: string) => {
      setValue(selectedValue);
      onChange(createAnswer(selectedValue));
    },
    [onChange],
  );

  const { onChangeText, ...rest } = useMaskedInput({
    value,
    onChangeText: handleChange,
    mask: inputMask && Masks[inputMask],
  });

  if (isParagraph) {
    return (
      <Flex w="full" align="flex-start">
        <FormControlComponent isInvalid={error}>
          <Textarea
            w="full"
            onChange={(e) => onChangeText(e.target.value)}
            {...rest}
          />
        </FormControlComponent>
        <AnswerHistory
          questionId={id}
          formularyId={formularyId}
          onSelect={handleSelect}
        />
      </Flex>
    );
  }

  return inputMask || inputMask !== 'NONE' ? (
    <Flex w="full" align="flex-start">
      <FormControlComponent isInvalid={error} mask={inputMask}>
        <Input
          w="full"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChangeText(e.target.value)
          }
          {...rest}
        />
      </FormControlComponent>
      <AnswerHistory
        questionId={id}
        formularyId={formularyId}
        onSelect={handleSelect}
      />
    </Flex>
  ) : (
    <Flex w="full" align="flex-start">
      <FormControlComponent isInvalid={error}>
        <Input
          w="full"
          onChange={(e) => handleChange(e.target.value)}
          value={value}
        />
      </FormControlComponent>
      <AnswerHistory
        questionId={id}
        formularyId={formularyId}
        onSelect={handleSelect}
      />
    </Flex>
  );
};

export default TextContent;
